import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { PropagateLoader } from "react-spinners";
import NoData from "../../atoms/NoData";
import useModal from "../../../hooks/useModal";
import Button from "../../atoms/Button";
import { MdDelete, MdEdit } from "react-icons/md";
import Modal from "../../molecules/Modal";
import ModalEditAdmin from "./ModalEditAdmin";
import ModalConfirm from "../../molecules/ModalConfirm";
import { toast } from "react-toastify";
import { DELETE_ADMIN, DELETE_USER } from "../../../api/apiAdmin";
import { getConditionalRowStyles } from "../../../styles/expandedStyles";

const AdminsTable = ({ data, loading, refetch }) => {
    const [admin, setAdmin] = useState();
    const { open:open2, close:close2, isOpen:isOpen2 } = useModal();
    const { open:open3, close:close3, isOpen:isOpen3 } = useModal();
    const [expandedRow, setExpandedRow] = useState(null);

    const handleOpenEdit = (admin) => {
        setAdmin(admin);
        open2();
    };

    const handleOpenDelete = (admin) => {
        setAdmin(admin);
        open3();
    };

    const handleDelete = async () => {
        try {
            await DELETE_ADMIN(admin?.id);
            await DELETE_USER(admin?.userId);
            toast.success("Eliminado correctamente");
            refetch();
            close3();
        } catch (error) {
            toast.error("Error al eliminar");
            console.error(error);
        }
    };

    const columns = [
        {name: "Nombre", selector: row => row?.name},
        {name: "Contacto", selector: row => (
            <div className="flex flex-col">
                <p>{row?.user?.email}</p>
                <p>{row?.cellphone}</p>
            </div>
        )},
        {name: "Acciones", cell: row => (
            <div className="flex flex-row space-x-2">
                <Button text={<MdEdit size={22}/>} bgColor="blue" width="w-10" onClick={()=> handleOpenEdit(row)}/>
                <Button text={<MdDelete size={22}/>} bgColor="red" width="w-10" onClick={()=> handleOpenDelete(row)}/>
            </div>
        )},
    ];

    const columnsResponsive = [
        {name: "Contacto", selector: row => (
            <div className="flex flex-col">
                <p>{row?.name}</p>
                <p>{row?.user?.email}</p>
                <p>{row?.cellphone}</p>
            </div>
        )},
    ];

    const ExpandedComponent = ({ data }) => (
        <div className="p-2 w-full flex flex-row justify-around">
            <Button text={<MdEdit size={22} />} bgColor="blue" width="w-10" onClick={() => handleOpenEdit(data)} />
            <Button text={<MdDelete size={22} />} bgColor="red" width="w-10" onClick={() => handleOpenDelete(data)} />
        </div>
    );    

    const conditionalRowStyles = getConditionalRowStyles(expandedRow);

    return(
        <div>
            <div className="block md:hidden">
                <DataTable
                    data={data}
                    progressPending={loading}
                    columns={columnsResponsive}
                    progressComponent={ <div className="w-full h-20 flex justify-center items-center"> <PropagateLoader color="red" /> </div> }
                    expandableRows
                    expandableRowsComponent={ExpandedComponent}
                    noDataComponent={<NoData/>}
                    pagination
                    responsive
                    expandableRowExpanded={(row) => row?.id === expandedRow?.id}
                    onRowExpandToggled={(expanded, row) => {
                        setExpandedRow(expanded ? row : null);
                    }}
                    conditionalRowStyles={conditionalRowStyles}
                />
            </div>
            <div className="hidden md:block">
                <DataTable
                    data={data}
                    progressPending={loading}
                    columns={columns}
                    progressComponent={
                        <div className="w-full h-20 flex justify-center items-center">
                            <PropagateLoader color="red" />
                        </div>
                    }
                    noDataComponent={<NoData/>}
                    pagination
                    responsive
                />
            </div>
            {isOpen2 && 
                <Modal title="Editar administrador" onClose={close2}>
                    <ModalEditAdmin admin={admin} onClose={close2} refetch={refetch}/>
                </Modal>
            }
            {isOpen3 && 
                <ModalConfirm onConfirm={handleDelete} onClose={close3} eliminacion />
            }
        </div>
    );
};

export default AdminsTable;